import { Stack } from '@mui/material';
import { IEntitlement } from 'API/compassRights';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { Entitlement } from './Entitlement';
import { HiddenAccessibilityText } from 'Components/HiddenAccessibilityText';
import { useContext } from 'react';
import { EntitlementsContext } from 'Context/CompassRightsContext/EntitlementsProvider';
import { useDictionary } from 'Hooks';
import { NoResults2 } from 'Components';

export const EntitlementsList = () => {
  const { entitlements } = useContext(EntitlementsContext);
  const dictionary = useDictionary(Dictionary, DICTIONARY.CompassRights);
  return (
    <Stack minHeight='200px' gap='24px'>
      <HiddenAccessibilityText
        text={`${dictionary.accessibilityFoundResults.found} ${entitlements?.filteredEntitlements?.length} ${dictionary.accessibilityFoundResults.results}`}
      />
      {entitlements?.filteredEntitlements?.length > 0 ? (
        entitlements?.filteredEntitlements?.map(
          (entitlement: IEntitlement, index: number) => {
            return <Entitlement entitlement={entitlement} key={index} />;
          }
        )
      ) : (
        <NoResults2 />
      )}
    </Stack>
  );
};
